import React, { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Row,
  Col,
  Input,
} from "antd";

import { formItemLayout, tailFormItemLayout } from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  addNew,
  onSearch,
  onDeleteItem,
  onChange,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import {
  PO_STATUS_PENDING,
  PO_STATUS_ACCOMPLISHED,
  PO_STATUS_CLOSED,
  APPROVED,
} from "../../utils/constants";
import { sumBy } from "lodash";
import { Link } from "react-router-dom";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";

const { Content } = Layout;

const url = "/api/condiments/";
const title = "Condiments Form";

const initialValues = {
  _id: null,
  po_no: null,
  date: moment(),
  supplier: null,
  remarks: "",
  items: [],
  discounts: [],

  gross_amount: 0,
  total_discount_amount: 0,
  total_amount: 0,
};

const initialItemValues = {
  stock: null,
  case_quantity: null,
  quantity: null,
  case_price: null,
  price: null,
  amount: null,
  received_case_quantity: 0,
  received_quantity: 0,
  has_at_least_one_selected: false,
  has_only_one_selection: false,
};

const date_fields = ["date"];

export default function CondimentsForm() {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);

  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
  });

  const [state, setState] = useState(initialValues);

  const supplierFormModal = useRef(null);

  const caseQuantityField = useRef(null);
  const quanttiyField = useRef(null);
  const casePriceField = useRef(null);
  const priceField = useRef(null);
  const amountField = useRef(null);
  const addItemButton = useRef(null);
  const stockField = useRef(null);

  const records_column = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Items",
      dataIndex: "items",
      render: (items) => (
        <span>{items.map((o) => o.stock?.name).join(", ")}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status, record, index) => {
        if (record.deleted && record.deleted.date) {
          return (
            <span className="has-text-danger has-text-weight-bold">VOIDED</span>
          );
        }

        return <span>{status && status.approval_status}</span>;
      },
    },
    {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <span
          onClick={() =>
            edit({
              record,
              setState,
              setErrors,
              setRecords,
              url,
              date_fields,
            })
          }
        >
          <i className="fas fa-edit"></i>
        </span>
      ),
    },
  ];

  const items_column = [
    {
      title: "Item",
      dataIndex: ["stock", "name"],
    },

    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) && isEmpty(state.deleted) && (
            <span
              onClick={() =>
                onDeleteItem({
                  field: "items",
                  index,
                  setState,
                })
              }
            >
              <i className="fas fa-trash-alt"></i>
            </span>
          )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const getLatestPrice = ({ stock, supplier }) => {
      if (state.supplier && item.stock) {
        axios
          .post("/api/products/latest-price", {
            supplier,
            stock,
          })
          .then((response) => {
            setItem((prev_items) => ({
              ...prev_items,
              price: response?.data?.price,
              case_price: response?.data?.case_price,
            }));
          });
      }
    };

    getLatestPrice({ stock: item.stock, supplier: state.supplier });
    return () => {};
  }, [item.stock, state.supplier]);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  useEffect(() => {
    setState((prevState) => {
      const total_amount = sumBy(state.items, (o) => o.amount);
      const gross_amount = total_amount;
      let net_amount = gross_amount;

      (state.discounts || []).forEach((discount) => {
        let discount_rate = validator.isNumeric(discount.toString())
          ? 1 - round(discount) / 100
          : 1;

        net_amount = net_amount * discount_rate;
      });

      const total_discount_amount = round(gross_amount - net_amount);

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
      };
    });

    return () => {};
  }, [state.items, state.discounts]);

  const onClosePO = () => {
    const loading = message.loading("Processing...");
    axios
      .post("/api/purchase-orders/close-po", {
        purchase_order: state,
      })
      .then((response) => {
        loading();
        setState((prevState) => ({
          ...prevState,
          po_status: response.data.po_status,
        }));
      })
      .catch((err) => {
        loading();
        message.error("There was an error processing your request");
      });
  };

  return (
    <Content className="content-padding">
      <SupplierFormModal
        setField={(supplier) => {
          setState((prevState) => ({
            ...prevState,
            supplier,
          }));
        }}
        ref={supplierFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              setState(initialValues);
              setItem(initialItemValues);
              setRecords([]);
            }}
          />
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: state,
                auth,
                url,
                setErrors,
                setState,
                date_fields,
              });
            }}
          >
            <TextFieldGroup
              label="Name"
              name="name"
              value={state.name}
              error={errors.name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="Requires 1 Selected"
              name="has_at_least_one_selected"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.has_at_least_one_selected}
              checked={state.has_at_least_one_selected}
              formItemLayout={formItemLayout}
            />
            <CheckboxFieldGroup
              label="Has only 1 Selection"
              name="has_only_one_selection"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.has_only_one_selection}
              checked={state.has_only_one_selection}
              formItemLayout={formItemLayout}
            />
            <CheckboxFieldGroup
              label="Print to OS"
              name="print_to_order_slip"
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
              error={errors.print_to_order_slip}
              checked={state.print_to_order_slip}
              formItemLayout={formItemLayout}
            />

            <TextFieldGroup
              label="# of Selection"
              name="required_no_of_selection"
              value={state.required_no_of_selection}
              error={errors.required_no_of_selection}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {isEmpty(state.status) &&
              isEmpty(state.deleted) && [
                <Divider orientation="left" key="divider">
                  Items
                </Divider>,
                <Row key="form" className="ant-form-vertical" gutter={4}>
                  <Col span={12}>
                    <SelectFieldGroup
                      key="1"
                      inputRef={stockField}
                      label="Item"
                      value={item.stock?.name}
                      onSearch={(value) =>
                        onStockSearch({ value, options, setOptions })
                      }
                      onChange={(index) => {
                        setItem({
                          ...item,
                          stock: options.stocks[index],
                        });
                        //addItemButton.current.click();
                      }}
                      error={errors.stock?.name}
                      formItemLayout={null}
                      data={options.stocks}
                      column="name"
                    />
                  </Col>

                  <Col
                    span={2}
                    className="is-flex align-items-center add-button-height"
                  >
                    <input
                      type="button"
                      ref={addItemButton}
                      className="button is-primary is-small"
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          items: [
                            ...prevState.items,
                            {
                              ...item,
                            },
                          ],
                        }));
                        setItem(initialItemValues);
                        stockField.current.focus();
                      }}
                      value="Add"
                    />
                  </Col>
                </Row>,
              ]}
            <Table
              dataSource={addKeysToArray(state.items)}
              columns={items_column}
              pagination={false}
            />

            {isEmpty(state.deleted) && (
              <Form.Item>
                <div className="field is-grouped m-t-1">
                  {state.status?.approval_status !== APPROVED && (
                    <div className="control">
                      <button className="button is-small is-primary">
                        Save
                      </button>
                    </div>
                  )}

                  {!isEmpty(state._id) && (
                    <span
                      className="button is-danger is-outlined is-small"
                      onClick={() => {
                        onDelete({
                          id: state._id,
                          url,
                          user: auth.user,
                        });
                        setState(initialValues);
                        setItem(initialItemValues);
                      }}
                    >
                      <span>Delete</span>
                      <span className="icon is-small">
                        <i className="fas fa-times"></i>
                      </span>
                    </span>
                  )}
                </div>
              </Form.Item>
            )}
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page) =>
                onSearch({
                  page,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                }),
              total: total_records,
              pageSize: 10,
            }}
          />
        )}
      </div>
    </Content>
  );
}
